import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import aboutImg from '../../../assets/img/about-img.png';

function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 bg-gray-100 text-gray-900 dark:text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="title-style text-4xl font-extrabold text-gray-800 dark:text-white sm:text-3xl">
            {t('about.title')}
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-16">
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <h3 className="zh-title-style text-3xl font-bold text-blue-600 mb-4 sm:text-2xl">
              {t('about.wintrissTitle')}
            </h3>
            <p className="text-gray-700 mb-6 leading-relaxed sm:text-base">
              {t('about.paragraph1')}
            </p>
            <p className="text-gray-700 mb-8 leading-relaxed sm:text-base">
              {t('about.paragraph2')}
            </p>
            <Link
              to="/about-us"
              className="inline-block px-8 py-3 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg shadow-md transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-500 focus:ring-opacity-50"
            >
              {t('about.learnMore')}
            </Link>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center lg:justify-start">
            <img
              src={aboutImg}
              alt="Company Introduction"
              className="rounded-lg shadow-xl w-full h-auto object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;